const boldTextDetector = (text = "") => {
    // const boldInQuotesRegex = /"(.*?)"|'(.*?)'/g; // "<text>"
    const boldInQuotesRegex = /\*\*([^*]+)\*\*/g; // **<text>**

    const parts = [];
    let lastIndex = 0;

    let match;
    while ((match = boldInQuotesRegex?.exec(text)) !== null) {
        const plainText = text?.slice(lastIndex, match.index);
        parts?.push(plainText);

        const boldText = match[1] || match[2];
        parts?.push(<strong key={match.index}>{boldText}</strong>);

        lastIndex = boldInQuotesRegex?.lastIndex;
    }

    const remainingText = text?.slice(lastIndex);
    parts.push(remainingText);

    return parts;

}

export default boldTextDetector;